const glossary = [
  {
    name: 'Active/Inactive',
    definition:
      'Refers to the two possible states in Binary objects (Binary Input, Binary Output, or Binary Value). In BACnet, binary properties typically have two states: Active (1) and Inactive (0).',
    purpose:
      'Used to indicate the operational state of a device or control point. For example, in a Binary Output for a fan, “Active” may mean the fan is running, while “Inactive” means it is off. This helps track on/off or enabled/disabled statuses of system components.',
  },
  {
    name: 'Alarm Value',
    definition:
      'A property specifying the threshold or value which, when reached or exceeded, triggers an alarm in the device. In a Binary Input object, for instance, the alarm value may be set to 0 (inactive) or 1 (active).',
    purpose:
      'This property helps monitor abnormal or specific conditions in the system, alerting operators when values are outside normal ranges.',
  },

  {
    name: 'Collection Type',
    definition:
      'Specifies the protocol or method used to collect data from a device. Common examples include 47808 (BACnet), 47807 (Siemens BACnet), or Modbus.',
    purpose: 'Indicates the protocol used by Onboard to communicate with the device.',
  },

  {
    name: 'Confidence',
    definition:
      'A percentage value indicating the level of certainty that the label or relationship predicted by Onboard’s AI is accurate.',
    purpose:
      'Helps users quickly assess which AI-predicted labels are most reliable and identify areas that may require manual review.',
  },

  {
    name: 'Deployment Name',
    definition:
      'A name assigned to your deployment in Onboard, typically formatted as Organization/Building (e.g., Onboard/HQ).',
    purpose:
      'Helps identify the source of building data within Onboard. A single deployment may serve multiple buildings, and a building may be linked to multiple deployments.',
  },

  {
    name: 'Description',
    definition:
      'An optional BACnet property that provides additional context or information about an object. If not specified during data discovery, this field is typically left blank.',
    purpose:
      'Allows for the inclusion of text to clarify an object’s purpose, usage, or operating instructions, helping in understanding its function or context.',
  },

  {
    name: 'Device Description',
    definition:
      'An optional field that provides extra details about the device, such as its function, location, or specific notes relevant to its operation.',
    purpose:
      'Offers additional context, helping operators understand the device’s role within the BAS. This field is particularly useful in large systems with many devices.',
  },

  {
    name: 'Device ID',
    definition:
      'A unique identifier assigned to each BACnet device on the network, allowing devices to recognize each other and communicate within the BACnet protocol.',
    purpose:
      'Essential for differentiating devices on the same network, ensuring commands and data are accurately directed between devices.',
  },

  {
    name: 'Device Model',
    definition:
      'The model name or number provided by the manufacturer, indicating the specific type or version of the device.',
    purpose:
      'Helps users understand the device’s capabilities, compatibility with other systems, and manufacturer specifications.',
  },

  {
    name: 'Device Name',
    definition:
      'Generally, a human readable name assigned to a BACnet device, identifying it within the system.',
    purpose:
      'This name aids in quickly recognizing the device’s role or location, facilitating easier navigation and troubleshooting.',
  },

  {
    name: 'Device Programs',
    definition: 'Represent one or many control programs that may be installed on the device.',
    purpose: 'Useful for identifying gateway devices that are linked to more than one equipment',
  },

  {
    name: 'Device Protocol',
    definition:
      'Specifies the communication protocol used by the device, such as BACnet or Modbus.',
    purpose: 'Helps in identifying what protocol was used to discover the device',
  },

  {
    name: 'Device Software',
    definition: 'Refers to the firmware or software version installed on the device.',
    purpose: 'Important for ensuring devices software are up-to-date',
  },

  {
    name: 'Device Vendor',
    definition:
      'Identifies the manufacturer or vendor of the device, often listed as a code or the vendor’s name.',
    purpose:
      'Useful for support, maintenance, and procurement, allowing users to source documentation, updates, or replacements from the manufacturer.',
  },

  {
    name: 'Equip Names',
    definition:
      'The display name for the equipment associated with the point, referring to the equipment entity (e.g., AHU-1,VAV-Lab) to which specific points or sensors belong. This name must be unique and cannot be shared with Location Name',
    purpose:
      'Provides a clear association between individual data points and their related equipment.',
  },

  {
    name: 'Equipment Type',
    definition:
      'A semantic DBO label that categorizes equipment (e.g. HVAC/AHU, HVAC/FAN, METER/EM) based on its role within the building system.',
    purpose:
      'Helps define and organize the equipment layout in a building.. The Mapping Engine provides predictions for Equipment Type, which users can modify as needed.',
  },

  {
    name: 'Location Name',
    definition:
      'A user-defined or descriptive name identifying the specific location (e.g., “Lobby East,” “Stairwell B,” “2nd Floor Corridor). This name must be unique and cannot be shared with Equipment Name',
    purpose: 'Provides a clear context to each location within the building layout.',
  },

  {
    name: 'Location Type',
    definition:
      'A semantic DBO label that describes the type of space where the equipment or another location is located, or a location that the equipment is serving. Allowed values include: Room, Corridor, Stairwell, and Floor.',
    purpose:
      'Enables spatial mapping in the Building Model, supporting hierarchy, and easier aggregation based on space types.',
  },

  {
    name: 'Object ID',
    definition:
      'The Object Identifier (Object ID) is a unique identifier within a BACnet device for each object it contains (e.g., Analog Input, Binary Output).',
    purpose:
      'Ensures no two objects within the same device share the same Object ID, providing a unique identifier for each object across the device.',
  },

  {
    name: 'Point Name',
    definition:
      'Corresponds to the sensor name in BAS, a user-friendly name given to each object (point) on the device (such as a sensor or actuator).',
    purpose:
      'This name serves as an easy-to-recognize identifier, making it simpler to locate and identify points in the system.',
  },

  {
    name: 'Point Type',
    definition:
      'A semantic DBO label applied to sensors, actuators, or setpoints, categorizing each point based on its function (e.g. zone_air_temperature_sensor, supply_air_static_pressure_setpoint, discharge_air_damper_command, ,energy_accumulator).',
    purpose:
      'Ensures each point is clearly identified within the system, making the building data standardized for easy interpretation and analysis. The Mapping Engine automatically populates suggested labels for Point Type, which users can edit as needed.',
  },

  {
    name: 'Present Value',
    definition:
      'The real-time value of a point (such as a sensor reading or control output) captured during data discovery.',
    purpose:
      'Reflects the latest state or measurement from the point which is essential for modeling data',
  },

  {
    name: 'Units',
    definition:
      'Defines the measurement units for the Present Value property of an object (e.g.  F, lb/in2, On/Off, kWh). The units are mapped to the QUDT system for consistency.',
    purpose:
      'Standardizing units ensures accurate interpretation and comparison of data across different buildings and geographies. This enables easy integrations with external applications',
  },
];

const getGlossary = () => glossary;

export default getGlossary;
